"use client"

import { useState } from "react"

const Button = ({ type = "primary", name, onClick, icon = "", isLoading = false, className = "" }) => {
  const [isHovered, setIsHovered] = useState(false)

  const buttonTypes = {
    primary: "btn-primary",
    secondary: "btn-secondary",
  }

  return (
    <button
      className={`min-w-[120px] h-12 px-6 ${buttonTypes[type]} cursor-pointer inline-flex justify-center items-center text-white text-base font-medium gap-2.5 transition-all duration-300 ${className} ${isLoading ? "opacity-70 cursor-wait" : ""}`}
      onClick={onClick}
      disabled={isLoading}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isLoading ? (
        <>
          <div className="loading-spinner mr-2"></div>
          <span>Loading...</span>
        </>
      ) : (
        <>
          <span>{name}</span>
          {icon && <span className="ml-1">{icon}</span>}
        </>
      )}
    </button>
  )
}

export default Button
